import { GraphQLAPI } from 'utils/RTKGraphQL';
import { mapToCamelCase } from 'resources/data/settings';

// Actions that should trigger a sync with the backend
const syncActionTypes = [
// Bulk settings update actions
'uisettings/setUISettings', 'languagesettings/setLanguageSettings', 'audiosettings/setAudioSettings', 'colorsettings/setColorSettings', 'quizsettings/setQuizSettings', 'skillsettings/setSkillSettings', 'datesettings/setDateSettings',
// Individual settings actions - UI settings
'uisettings/toggleDarkMode', 'uisettings/setFontFamily', 'uisettings/setCharSize', 'uisettings/setPinyinSize', 'uisettings/setCharSpaceVal', 'uisettings/toggleShowOutline', 'uisettings/toggleShowCharacter',
// Individual settings actions - Language settings
'languagesettings/toggleTraditional', 'languagesettings/toggleShowPinyin', 'languagesettings/toggleShowRead', 'languagesettings/toggleAudioDownload',
// Individual settings actions - Audio settings
'audiosettings/setSpeed', 'audiosettings/setVolume',
// Individual settings actions - Color settings
'colorsettings/toggleCharColors', 'colorsettings/togglePinyinColors', 'colorsettings/toggleGlobalDash', 'colorsettings/setToneColor',
// Individual settings actions - Quiz settings
'quizsettings/toggleFrontWord', 'quizsettings/toggleFrontDefinition', 'quizsettings/toggleFrontPinyin', 'quizsettings/toggleFrontAudio', 'quizsettings/toggleBackWord', 'quizsettings/toggleBackDefinition', 'quizsettings/toggleBackPinyin', 'quizsettings/toggleBackAudio', 'quizsettings/setWordSelection', 'quizsettings/setLimitSelection', 'quizsettings/setMemLimitSelection', 'quizsettings/setShowHintAfterMiss', 'quizsettings/setSentenceSelection',
// Individual settings actions - Skill settings
'skillsettings/setSkill', 'skillsettings/setCats', 'skillsettings/setSkillSelected',
// Individual settings actions - Date settings
'datesettings/setStartDate', 'datesettings/setEndDate',
// Individual settings actions - Collapse settings
'collapsesettings/setDictCollapse', 'collapsesettings/setSentenceCollapse', 'collapsesettings/setRulesCollapse'];
export const settingsSyncMiddleware = store => next => async action => {
  // Execute the action first
  const result = next(action);

  // Check if this action should trigger a sync
  if (syncActionTypes.includes(action.type)) {
    const state = store.getState();
    const isAuthenticated = !!state.profile;
    if (isAuthenticated) {
      try {
        // Combine all settings slices
        const combinedSettings = {
          ...state.uisettings,
          ...state.languagesettings,
          ...state.audiosettings,
          ...state.colorsettings,
          ...state.quizsettings,
          ...state.skillsettings,
          ...state.datesettings,
          ...state.collapsesettings
        };
        const mappedSettings = mapToCamelCase(combinedSettings);

        // Dispatch API call to update settings
        await store.dispatch(GraphQLAPI.endpoints.createOrUpdateUserSettings.initiate({
          userId: state.profile.id,
          ...mappedSettings
        }));
      } catch (error) {
        console.error('Error syncing settings:', error);
        store.dispatch({
          type: 'settingsSyncFailure',
          payload: error
        });
      }
    }
  }
  return result;
};